import { render } from "./EyerwebPatientExamTab.vue?vue&type=template&id=8e62481c&scoped=true"
import script from "./EyerwebPatientExamTab.vue?vue&type=script&lang=js"
export * from "./EyerwebPatientExamTab.vue?vue&type=script&lang=js"

import "./EyerwebPatientExamTab.vue?vue&type=style&index=0&id=8e62481c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e62481c"]])

export default __exports__